import type { TransactionOperation } from "."
import { deletePanels } from "./deletePanels"
import { panelIndex } from "../panels"
import { getPanelIsError } from "../panels/validation"

export const deleteAllInvalidPanels: TransactionOperation = (transactors) => {
  const { get } = transactors
  const panelIds = get(panelIndex)
  const invalidPanelIds = panelIds.filter((panelId) => {
    const panelIsError = getPanelIsError(transactors, panelId)

    return panelIsError
  })
  deletePanels(transactors, new Set(invalidPanelIds))
}
